import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TrendDirection} from '@shared/api/models/query/patient-daily-snapshot.model';

/**
 * Maps a raw API trend string onto {@link TrendDirection}. The backend's `ScoreTrendEnum`
 * only ever emits 'up' | 'down' | 'same'; anything else (null, undefined, or an off-contract
 * value) is "unknown" (`null`) and is never coerced to 'same' (stable).
 */
export function toTrendDirection(value: string | null | undefined): TrendDirection | null {
    switch (value) {
        case 'up':
        case 'down':
        case 'same':
            return value;
        default:
            return null;
    }
}

@Component({
    selector: 'cdss-trend-icon',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './trend-icon.component.html',
    styleUrl: './trend-icon.component.scss'
})
export class TrendIconComponent {
    /** `null` = unknown / no data (renders a dash); `'same'` = stable. They are distinct. */
    @Input() trend: TrendDirection | null = null;
}
